var _circle, _polygon, _polygon2, _polygon3, _polygon4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViewfinder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.91,
    cy: 50.59,
    r: 4.79
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "13.11 23.68 9.48 23.68 9.48 9.28 18.16 9.28 18.16 12.9 13.11 12.9 13.11 23.68"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.52 23.68 86.89 23.68 86.89 12.9 81.84 12.9 81.84 9.28 90.52 9.28 90.52 23.68"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "18.16 90.72 9.48 90.72 9.48 76.31 13.11 76.31 13.11 87.1 18.16 87.1 18.16 90.72"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.52 90.72 81.84 90.72 81.84 87.1 86.89 87.1 86.89 76.31 90.52 76.31 90.52 90.72"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewfinder);
export default __webpack_public_path__ + "static/media/viewfinder.df886f07f8e73b047f2cbcc83e66dcd4.svg";
export { ForwardRef as ReactComponent };